import { AppData } from "@/src/constants/app-data";
import { Menu, ShoppingBag } from "lucide-react";

interface NavbarProps {
    transparent: boolean;
    cartCount: number;
    onMenuOpen: () => void;
    onCartOpen: () => void;
}

export function Navbar({
    transparent,
    cartCount,
    onMenuOpen,
    onCartOpen,
}: NavbarProps) {
    return (
        <nav
            className={`fixed top-0 w-full z-50 transition-all duration-500 ${transparent ? "bg-transparent py-6 text-white" : "glass py-4 shadow-sm text-stone-900"}`}
        >
            <div className="max-w-7xl mx-auto px-6 flex justify-between items-center">
                <button
                    onClick={onMenuOpen}
                    className="p-2 hover:opacity-60 transition-opacity"
                >
                    <Menu size={24} strokeWidth={1.5} />
                </button>

                <a href="/">
                    <h1 className="font-serif text-3xl tracking-widest uppercase font-light">
                        {AppData["AppName"]}
                    </h1>
                </a>

                <button
                    onClick={onCartOpen}
                    className="p-2 relative hover:opacity-60 transition-opacity"
                >
                    <ShoppingBag size={24} strokeWidth={1.5} />
                    {cartCount > 0 && (
                        <span className="absolute top-0 right-0 bg-stone-800 text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center">
                            {cartCount}
                        </span>
                    )}
                </button>
            </div>
        </nav>
    );
}
